import React, {useState, useEffect} from 'react'
import '../../Work-css/Reviews.css';
import Revs_web from '../../Revs/Revs_web';
import Rev_News from '../../Revs/Rev_News';

function Reviews({revs}) {

const [rev_web, setRev_web] = useState(false)
const [rev_news, setRev_news] = useState(true)

  return (
      <div className='Revs'>
         {rev_web==true?( <div className='rev_web_div'><Revs_web rev_web={setRev_web} rev_news={setRev_news} /></div>):('')}
         {rev_news==true?( <div className='rev_web_div'><Rev_News rev_web={setRev_web} rev_news={setRev_news} /></div>):('')}
          
      </div>
  )
}

export default Reviews